var straps_upsale_json = {
  "upsales_pt2Sfx1v881": [
    {
      "straps": {
        "config": {
          "product": {
            "enable": true,
            "messageenable": false,
            "messagetext": "30% off any strap with every watch purchase"
          },
          "cart": {
            "enable": true,
            "messageenable": false,
            "messagetext": ""
          }
        },
        "notes1": "available collections loads from up-sell-collections.liquid and set to: 24mm-straps,22mm-straps,20mm-straps",
        "notes2": "straps are loaded according to lugs_x tag, while these collections override if necessary",
        "collections": [
          {
            "object_sku_group": "T101",
            "collection": "22mm-straps",
            "excludetags": "TN/5087BR22SV"
          }
        ]
      },
      "lowerstrapsection": {
        "enable": false,
        "config": {
          "productpage": {
            "enable": true,
            "messageenable": true,
            "messagetext": "Holiday Gift Wrap - High quality box for your selected watch and additional strap",
            "image": "https://cdn.shopify.com/s/files/1/2372/2167/files/watch-strap-box-featured.jpg?v=1606500378"
          },
          "cart": {
            "enable": false,
            "messageenable": false,
            "messagetext": ""
          },
          "conditions": {
            "show": {
              "operator": "AND",
              "logic": [
                {
                  "object": "cart",
                  "condition": "has item type",
                  "subject": "Watches",
                  "qty": ">0"
                },
                {
                  "object": "cart",
                  "condition": "has item type",
                  "subject": "Straps",
                  "qty": ">0"
                }
              ]
            }
          },
          "variant": {
            "type": "box",
            "belong_to_collection_handle": "giftboxes",
            "sku": "P-B-TORGGFTBOX01"
          }
        }
      }
    }
  ]
}